import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M7.36625 7.25077C7.35554 4.39122 9.55979 2.05078 12.2616 2.05078C14.9521 2.05078 17.1471 4.36003 17.1471 7.2293C17.1471 10.1292 14.988 12.525 12.2616 12.525C9.53012 12.525 7.36722 10.1348 7.36625 7.25077ZM12.2616 3.95078C10.7061 3.95078 9.25843 5.33975 9.26624 7.24493L9.26626 7.24883C9.26625 9.22725 10.7163 10.625 12.2616 10.625C13.793 10.625 15.2471 9.23174 15.2471 7.2293C15.2471 5.31341 13.8093 3.95078 12.2616 3.95078Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M18.5038 19.2733C18.5038 19.2733 18.5038 19.2728 18.5039 19.272ZM18.37 18.6562C18.1794 18.1575 17.7658 17.514 17.0066 16.8884C15.9347 16.005 14.3212 15.3027 12.252 15.3027C10.1883 15.3027 8.57431 16.0046 7.50028 16.8889C6.74008 17.5149 6.32573 18.1582 6.1346 18.6562C6.14556 18.6562 6.15669 18.6562 6.16797 18.6562H18.3359C18.3475 18.6562 18.3588 18.6562 18.37 18.6562ZM18.3359 20.6562H6.16797C4.55664 20.6562 4 20.168 4 19.2695C4 16.7598 7.19336 13.3027 12.252 13.3027C17.3203 13.3027 20.5039 16.7598 20.5039 19.2695C20.5039 20.168 19.9473 20.6562 18.3359 20.6562Z"
      fillRule="evenodd"
    />
  </>,
  'OutlinePerson',
)
